import { Group, User, GroupPrivacy } from '@wellesley/openapi'

export type ChannelFormProps = {
  group: Group
  values?: Partial<ChannelFormType>
  disabled?: boolean
  handleCancel?: () => void
  handleSubmit?: (channel: User) => void
  renderTopPanel?: ({ disabled }: { disabled: boolean }) => React.ReactNode
  onDirtyChange?: (isDirty: boolean) => void
}

export enum ChannelPrivacyOptions {
  public = 'Public',
  private = 'Private',
}

export type ChannelFormType = {
  channelName: string
  channelSlug: string
  privacy: ChannelPrivacyOptions
  globalUrl?: string
  addGlobalUrl: boolean
  autoSubscribe: boolean
}

export type ChannelFormState = {
  canAddGlobalUrl: boolean
  isSubmitDisabled: boolean
  isLoading: boolean
}

export type ChannelPrivacyConfig = {
  groupPrivacy: GroupPrivacy
  channelPrivacy: ChannelPrivacyOptions
}

export type UseCreateGroupChannelProps = {
  groupName: string
  onSuccessCreation?: (channel: User) => void
}

export type UseCreateGroupChannelReturn = {
  createChannel: () => void
  CreateChannelDialog: React.ReactNode | null
}
